export const useChooseRelevantInstance = async (
  documentId: string,
  allRelevantInstances: EvaluationRelevantInstance[],
  chosenInstance: EvaluationRelevantInstance,
  activeTypes: string[],
  activeSubTypes: string[]
) => {
  const tokens = [] as ParagraphTokens;

  for (const relevantInstanceToken of chosenInstance.tokens) {
    const token = useDocumentTokenIdPositionMapStore(
      documentId
    ).tokenStoreFromId(relevantInstanceToken.id).token;

    if (token == undefined) {
      continue;
    }

    token.indicators = {
      markers: token.indicators?.markers ?? [],
      types: activeTypes,
      subTypes: activeSubTypes,
    };

    const tokenCopy = {
      ...token,
    };

    tokens.push(tokenCopy);
  }

  const nonChosenInstances = allRelevantInstances.filter(
    (instance) => instance.uid !== chosenInstance.uid
  );

  for (const nonChosenInstance of nonChosenInstances) {
    nonChosenInstance.forceHide = true;

    for (const token of nonChosenInstance.tokens) {
      const tokenStore = useDocumentTokenIdPositionMapStore(
        documentId
      ).tokenStoreFromId(token.id);

      if (tokenStore.token == undefined) {
        continue;
      }

      if (tokenStore.token.indicators == undefined) {
        tokenStore.token.indicators = {
          markers: [],
          types: [],
          subTypes: [],
        };
      }

      tokenStore.token.indicators.types =
        tokenStore.token.indicators.types.filter(
          (type) => !activeTypes.includes(type)
        );

      tokenStore.token.indicators.subTypes =
        tokenStore.token.indicators.subTypes.filter(
          (subType) => !activeSubTypes.includes(subType)
        );
    }
  }

  await useDocumentParagraphsStore(documentId).saveTokens(tokens);
};
